import { useAtomValue } from 'jotai';
import { drumSelectedCognitiveAtom } from '../../../shared/store/drumAppAtoms';
import type { ExecutiveGameType } from './cognitiveGameShared';
import ColorCognitionGame from './ColorCognitionGame';
import ExecutiveColorGame from './ExecutiveColorGame';
import './CognitiveGame.scss';

function resolveGameKind(code: string): ExecutiveGameType | 'color-cognition' {
  const normalized = code.toLowerCase();
  if (normalized.includes('stroop')) return 'stroop';
  if (normalized.includes('rule')) return 'rule';
  return 'color-cognition';
}

function CognitiveGame() {
  const activity = useAtomValue(drumSelectedCognitiveAtom);
  const kind = resolveGameKind(activity?.playCode || activity?.id || '');
  if (kind === 'color-cognition') return <ColorCognitionGame />;
  return <ExecutiveColorGame type={kind} />;
}

export default CognitiveGame;
